import React, { useState, useEffect, useRef } from "react";
import {
  Stack,
  Card,
  CardContent,
  Button,
  Typography,
  CardActions,
  Grid,
} from "@mui/material";
import ConfirmDialog from "../../helper/ConfirmDialog";
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DownloadIcon from "@mui/icons-material/Download";
import fileDownload from "js-file-download";
import { globalService } from "../../../services/GlobalService";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { SocietyBuildingUnitTransfersService } from "../../../services/SocietyBuildingUnitTransfersService";
import { useSharedNavigation } from "../../../utility/context/NavigationContext";
import { Messages } from "../../../utility/Config";
import { SocietyBuildingUnitSubscriptionBalancesService } from "../../../services/SocietyBuildingUnitSubscriptionBalancesService";
import { SelectListModel } from "../../../models/ApiResponse";
import Controls from "../../../utility/controls/Controls";
import useForm from "../../../utility/hooks/UseForm";
import { SocietyBuildingUnitSubscriptionBalancesModel } from "../../../models/SocietyBuildingUnitSubscriptionBalancesModel";
import { societyBillSeriesService } from "../../../services/SocietyBillSeriesService";

const SocietyBuildingUnitSubscriptionBalancesExcelUpload = (...props: any) => {
  const fileInputRef = useRef(null);
  const { societyBuildingId } = useParams();
  let societyId = localStorage.getItem("societyId");
  let societySubscriptionId = localStorage.getItem("societySubscriptionId");
  const [societyBuildingUnitSubscriptionBalancesExcelUpload, setSocietyBuildingUnitSubscriptionBalancesExcelUpload] = useState([]);
  const [files, setFiles] = useState<File[]>([]);
  const [billAbbreviation, setBillAbbreviation] = useState<SelectListModel[]>([]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => { },
  });
  const navigate = useNavigate();
  const { goToHome } = useSharedNavigation();

  const validate = (fieldValues: SocietyBuildingUnitSubscriptionBalancesModel = values) => {
    let temp: any = { ...errors };
    if ("BillAbbreviation" in fieldValues)
      temp.BillAbbreviation = fieldValues.BillAbbreviation ? "" : "Please Select Bill Abbreviation.";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(
      SocietyBuildingUnitSubscriptionBalancesService.initialFieldValues,
      validate,
      props.SocietyBuildingUnitSubscriptionBalanceId
    );

  const newAchead = () => {
    setValues(SocietyBuildingUnitSubscriptionBalancesService.initialFieldValues);
  };

  useEffect(() => {
    if (billAbbreviation.length === 0) getBillAbbreviation();
    if (!globalService.isSocietySelected()) {
      globalService.info(Messages.SocietyUnSelected);
      return goToHome();
    }
  }, []);

  const getBillAbbreviation = () => {
    societyBillSeriesService.getSelectListBySocietyId(societyId).then((response) => {
      setBillAbbreviation(response.data);
      values.BillAbbreviations = response.data[0].Value;
    });
  };

  const handleFileSelect = () => {
    const files = fileInputRef.current.files;
    console.log(files);
  };
  const downloadTemplate = () => {
    SocietyBuildingUnitSubscriptionBalancesService.downloadTemplate(societyId,societyBuildingId).then((response) => {
      let result = response.data;
      fileDownload(result, "SocietyBuildingUnitSubscriptionBalancesExcelUpload.xlsx");
    });
  };

  const onFileChange = (fileInput: any) => {
    setFiles(fileInput.target.files);
  };

  const uploadFile = () => {
    if (!validate()) return;
    let payload = {
      SocietyBuildingId: societyBuildingId,
      societyId: societyId,
      societySubscriptionId: societySubscriptionId,
      BillAbbreviation: values.BillAbbreviation?.trim()
    };
    SocietyBuildingUnitSubscriptionBalancesService.uploadExcel(files, payload).then((response) => {
      if (response) {

        let result = response.data;
        if (result.list != null) {
          setSocietyBuildingUnitSubscriptionBalancesExcelUpload(result.list);
        }
        if (result.isSuccess) {
          globalService.success(result.message);
          // resetForm();
        } else {
          globalService.error(result.message);
        }
      }
    });
  };

  const columns: GridColDef[] = [
    { field: "Flat", headerName: "Flat", width: 50, flex: 1 },
    { field: "MemberName", headerName: "Member Name", width: 130, flex: 1 },
    { field: "BillAbbreviation", headerName: "BillAbbreviation", width: 130, flex: 1 },
    { field: "PrincipalAmount", headerName: "Principal Amount", width: 130, flex: 1 },
    { field: "InterestAmount", headerName: "Interest Amount", width: 130, flex: 1 },
    { field: "PrincipalReceipt", headerName: "PrincipalReceipt", width: 130, flex: 2 },
    { field: "InterestReceipt", headerName: "Interest Receipt", width: 130, flex: 2 },
    { field: "SpecialBillAmount", headerName: "Special BillAmount", width: 130, flex: 2 },
    { field: "SpecialBillReceipt", headerName: "Special BillReceipt", width: 130, flex: 2 },
    { field: "Remarks", headerName: "Remarks", width: 130, flex: 2 },
    { field: "TaxAmount", headerName: "TaxAmount", width: 130, flex: 2 },
    { field: "TaxReceipt", headerName: "TaxReceipt", width: 130, flex: 2 },
    { field: "Advance", headerName: "Advance", width: 130, flex: 2 },
    { field: "AdvanceAdjusted", headerName: "Advance Adjusted", width: 130, flex: 2 },
  ];

  return (
    <>
      <Stack direction="row" spacing={0} justifyContent="space-between">
        <Typography variant="h5">Opening Balance Excel Upload</Typography>
      </Stack>
      <Card>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <Controls.Select
                name="BillAbbreviation"
                required
                label="Bill Abbreviation"
                showEmptyItem={false}
                value={billAbbreviation.length > 0 ? values.BillAbbreviation : ""}
                onChange={handleInputChange}
                options={billAbbreviation}
                error={errors.BillAbbreviation}
              />
            </Grid>
          </Grid> <br />
          <div>
            <input
              type="file"
              ref={fileInputRef}
              onChange={(event: any) => {
                onFileChange(event);
              }}
            // onChange={handleFileSelect}
            />

            <Button variant="contained" color="primary" onClick={uploadFile}>
              Upload Excel
            </Button>
            <Button
              style={{ marginLeft: '3vh' }}
              variant="contained"
              color="secondary"
              className="m-l-5"
              startIcon={<DownloadIcon />}
              onClick={downloadTemplate}
            >
              Template
            </Button>

            <Stack direction="row" spacing={0} justifyContent="space-between">
              <Typography variant="h5">Error Lists</Typography>
              {/* <Typography  style={{color: 'red', fontSize: '0.75rem'}}>Note: Transfer Date should be prefix with single quote (') in excel. (e.g. '01/Apr/2023)
</Typography> */}
            </Stack>

            <DataGrid
              getRowId={(row) => row.SocietyBuildingUnitSubscriptionBalanceImportId}
              rows={societyBuildingUnitSubscriptionBalancesExcelUpload}
              columns={columns}
              columnHeaderHeight={30}
              //rowHeight={30}
              autoHeight={true}
              getRowHeight={() => "auto"}
              getEstimatedRowHeight={() => 200}
              //loading={loading}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns Id, the other columns will remain visible
                    SocietyBuildingUnitSubscriptionBalanceImportId: false,
                  },
                },
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              pageSizeOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardContent>
        <CardActions sx={{ display: "flex", justifyContent: "center" }}>
          <Stack spacing={2} direction="row">
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
            >
              Back To List
            </Button>
          </Stack>
        </CardActions>
      </Card>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>
  );
};

export default SocietyBuildingUnitSubscriptionBalancesExcelUpload;
